<template>
  <div class="md-layout md-gutter moreInfoGroup">
    <div class="md-layout-item md-size-33">
      <md-field>
        <select v-model="$store.state.plot.localization.main_function" name="mainFunction" @change="changeMainFunction()">
          <option disabled value="">{{ $t("localization.mainFunction") }}</option>
          <option v-for="(mf, key) in mainFunctionList" :value="key" :key="key">{{ mf }}</option>
        </select>
      </md-field>
    </div>
    <div class="md-layout-item md-size-33">
      <md-field>
        <select v-model="$store.state.plot.localization.specific_function" name="group" @change="changeSpecificFunction()">
          <option disabled value="">{{ $t("localization.specificFunction") }}</option>
          <option v-for="(spe, key) in specific" :value="key" :key="key">{{ spe }}</option>
        </select>
      </md-field>
    </div>
    <div class="md-layout-item md-size-33">
      <md-field>
        <select v-model="$store.state.plot.localization.specific_function_detail" name="specificFunctionDetail">
          <option disabled value="">{{ $t("localization.specificFunctionDetail") }}</option>
          <option v-for="(det, key) in detailed" :value="key" :key="key">{{ det }}</option>
        </select>
      </md-field>
    </div>
  </div>
</template>

<script>
import { getDomain } from '@/assets/scripts/domainsManager'

const MAIN_FUNCTION = 'main_function'
const SPECIFIC_FUNCTION = 'specific_function'
const SPECIFIC_FUNCTION_DETAIL = 'specific_function_detail'

export default {
  name: 'Management',
  data: () => ({
    mainFunctionList: {},
    specificFunctionList: {},
    specificFunctionDetailList: {},
    loadSpecific: false,
    loadDetailed: false
  }),
  mounted () {
    getDomain(MAIN_FUNCTION).then(data => {
      this.mainFunctionList = data[this.$i18n.locale]
    })
    getDomain(SPECIFIC_FUNCTION).then(data => {
      this.specificFunctionList = data[this.$i18n.locale]
      this.loadSpecific = true
    })
    getDomain(SPECIFIC_FUNCTION_DETAIL).then(data => {
      this.specificFunctionDetailList = data[this.$i18n.locale]
      this.loadDetailed = true
    })
  },
  computed: {
    specific: function () {
      if (this.loadSpecific) {
        return this.specificFunctionList[this.$store.state.plot.localization.main_function]
      } else {
        return {}
      }
    },
    detailed: function () {
      if (this.$store.state.plot.localization.main_function.length > 0) {
        if (this.loadDetailed) {
          return this.specificFunctionDetailList[this.$store.state.plot.localization.main_function][this.$store.state.plot.localization.specific_function]
        } else {
          return {}
        }
      } else {
        return {}
      }
    }
  },
  methods: {
    changeMainFunction: function () {
      this.$store.state.plot.localization.specific_function = ''
      this.$store.state.plot.localization.specific_function_detail = ''
    },

    changeSpecificFunction: function () {
      this.$store.state.plot.localization.specific_function_detail = ''
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';
</style>
